import { render, staticRenderFns } from "./Verification.vue?vue&type=template&id=0f94e811&scoped=true&"
import script from "./Verification.vue?vue&type=script&lang=ts&"
export * from "./Verification.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f94e811",
  null
  
)

export default component.exports